
import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import image1 from '../images/image1.jpg';
import image2 from '../images/image2.jpg';
import image3 from '../images/image3.jpg';

const images = [image1, image2, image3];

const Welcome = () => {
  const [current, setCurrent] = useState(0);
  const { theme } = useContext(ThemeContext);

  const prevSlide = () => {
    setCurrent(current === 0 ? images.length - 1 : current - 1);
  };

  const nextSlide = () => {
    setCurrent(current === images.length - 1 ? 0 : current + 1);
  };

  useEffect(() => {
    const slideInterval = setInterval(nextSlide, 5000); // Auto-scroll every 5 seconds
    return () => clearInterval(slideInterval);
  });

  const containerClasses = `relative w-full max-w-7xl mx-auto my-4 md:my-8 shadow-2xl rounded-lg overflow-hidden ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'}`;

  return (
    <div className={containerClasses}>
      <div className="relative w-full h-[50vh] md:h-[75vh] overflow-hidden">
        <div className="flex transition-transform ease-out duration-500" style={{ transform: `translateX(-${current * 100}%)` }}>
          {images.map((img, index) => (
            <img key={index} src={img} alt={`slide ${index}`} className="w-full h-full object-contain flex-shrink-0" />
          ))}
        </div>

        {/* Navigation Arrows */}
        <button onClick={prevSlide} className="absolute top-1/2 left-2 md:left-4 transform -translate-y-1/2 bg-black bg-opacity-30 text-white p-2 md:p-3 rounded-full hover:bg-opacity-50 transition">
          <FiChevronLeft size={24} />
        </button>
        <button onClick={nextSlide} className="absolute top-1/2 right-2 md:right-4 transform -translate-y-1/2 bg-black bg-opacity-30 text-white p-2 md:p-3 rounded-full hover:bg-opacity-50 transition">
          <FiChevronRight size={24} />
        </button>

        {/* Navigation Dots */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
          {images.map((_, index) => (
            <button key={index} onClick={() => setCurrent(index)} className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition ${current === index ? 'bg-white' : 'bg-gray-400'}`}></button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Welcome;
